import React, { useRef, useState, useEffect } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './category.css';



import { Skeleton } from 'primereact/skeleton';
import ProductImage from '../../assets/images/product/product.svg';
import Hearth from '../../assets/icons/hearth.svg';

import { GetListPack, GetListGroupKala } from '../../utils/api';


export default function Categories({ type,categoriesList }) {
  const [swiperRef, setSwiperRef] = useState(null);
  const [loading, setLoading] = useState(true); // حالت لودینگ


  const settings = {
    arrows: false, // نمایش یا عدم نمایش پیکان‌ها
    autoplaySpeed: 3000,

    responsive: [
        {
            breakpoint: 3000,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                rtl: categoriesList?.length > 5,
                autoplay: categoriesList?.length > 5, // فعال‌سازی خودکار
                draggable: categoriesList.length > 5,
                infinite: categoriesList.length > 5, // حلقه‌ای شدن اسلایدر
            },
        },
        {
            breakpoint: 1400,
            settings: {
                rtl: categoriesList?.length > 5,
                slidesToShow: 5,
                slidesToScroll: 1,
                arrows: true,
                autoplay: categoriesList?.length > 5, // فعال‌سازی خودکار
                draggable: categoriesList.length > 5,
                infinite: categoriesList.length > 5, // حلقه‌ای شدن اسلایدر
            },
        },
        {
            breakpoint: 1100,
            settings: {
                rtl: categoriesList?.length > 4,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                autoplay: categoriesList?.length > 4, // فعال‌سازی خودکار
                draggable: categoriesList.length > 4,
                infinite: categoriesList.length > 4, // حلقه‌ای شدن اسلایدر
            },
        },
        {
            breakpoint: 980,
            settings: {
                rtl: categoriesList?.length > 3,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                autoplay: categoriesList.length > 3, // اضافه کردن autoplay در اینجا
                autoplaySpeed: 3000,
                draggable: categoriesList.length > 3,
                infinite: categoriesList.length > 3,
            },
        },
        {
            breakpoint: 768,
            settings: {
                rtl: categoriesList?.length > 3,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                autoplay: categoriesList.length > 3, // اضافه کردن autoplay در اینجا
                autoplaySpeed: 3000,
                draggable: categoriesList.length > 3,
                infinite: categoriesList.length > 3,
            },
        },
    ],
};




  return (
    <>

      <Slider {...settings} adaptiveHeight={true}>
        {categoriesList.map((category, index) => {
          return (
            <>
              <div className='d-flex items-center justify-center flex-column category-list'>
                <div className='category-img'>
                  <img src={category.Pic_A
                    ? category.Pic_A
                    : ProductImage} className='img-box img-category' alt="Image 1" />
                </div>
                <h6 className='text-base font-bold mt-2 text-[#242526]'>{category.GrpName}</h6>
              </div>
            </>
          );
        })}
      </Slider>


    </>
  );
}
